import React, { useState, useEffect, useRef } from 'react'
import { Grid } from '@mui/material';
import { useStyle } from "./Style";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { getS3BucketSignedUrlForPolicyDcpDocuments } from '../../../../../../../lib/requests.es6';
import ProgressState from './ProgressState';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import ModalInc from '../../../../../../../shared-ui/ModalInc';
import ButtonInc from '../../../../../../../shared-ui/ButtonInc';
import { reloadPage } from '../../../../../../../lib/utils.es6';


const PolicyDocuments = (props) => {
  const classes = useStyle();

  const [step, setStep] = useState(1);
  const [docType, setDocType] = useState('');
  const [s3Url] = useState('https://policy-onboarding-documents.s3.amazonaws.com');
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const savingStarted = useRef(false);
  // savingDocument is the shared upload flag, raised by every policy document
  // upload in the page — including the ones inside the AML/PEP decision
  // modals. Reloading on those would close the modal under the reviewer, so
  // only an upload started here reloads to refresh this list.
  const ownUpload = useRef(false);

  useEffect(function() {
    if (props.savingDocument && ownUpload.current) {
      savingStarted.current = true;
    }
    if (savingStarted.current && !props.savingDocument) {
      savingStarted.current = false;
      ownUpload.current = false;
      reloadPage();
    }
  }, [props.savingDocument]);

  const handleFinishedUpload = (info) => {
    setUploading(false);
    const payload = {
      policy_guid: props.policy_guid,
      description: docType,
      filename: docType,
      url: info.fileUrl.replace('undefined', info.bucketKey),
    }
    ownUpload.current = true;
    props.DocumentUpload(payload);
  }

  const getS3Ur = (file, callback) => getS3BucketSignedUrlForPolicyDcpDocuments(props.policy_guid, file, callback)

  const uploadOptions = {
    getSignedUrl: getS3Ur,
    s3Url: s3Url,
    uploadRequestHeaders: {},
    onProgress: (progress) => { setProgress(progress); setUploading(true); },
    onError: (errorMessage) => { setErrorMessage(errorMessage); setUploading(false); },
  };

  const handleChange = (event) => {
    const { name, value } = event.target
    if (name === "docsdescription") {
      setDocType(value);
    }
  }

  return (
    <>
      <ModalInc
        modalTitle="Add policy document"
        subTitle={step === 1 ? "Enter a description for the document" : "Upload your document"}
        open={props.openPolicyDocumentDialog}
        onClose={uploading || props.savingDocument ? undefined : props.toggleOpenPolicyDocumentDialog}
        fullWidth
      >

        {step === 1 && (
          <ValidatorForm onSubmit={() => setStep(2)}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  id="docType"
                  value={docType}
                  name='docsdescription'
                  type="text"
                  label="Document Description"
                  placeholder="Enter document description"
                  onChange={handleChange}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter document description']}
                  style={{ width: "100%" }}
                  sx={{
                    fontFamily: "Open Sans",
                    fontStyle: "normal",
                    fontWeight: 300,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0.005em",
                    color: "#000000",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}></Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={8} md={8}>
                    <ButtonInc
                      type="submit"
                      size="large"
                      variant="contained"
                      style={{ float: 'right', marginTop: "20px" }}
                    >
                      Next
                    </ButtonInc>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <ButtonInc
                      variant="contained"
                      color="primary"
                      size="large"
                      style={{ marginTop: "20px" }}
                      onClick={props.toggleOpenPolicyDocumentDialog}
                    >
                      Cancel
                    </ButtonInc>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ValidatorForm>
        )}

        {step === 2 && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <div className={classes.uploadsection}>
                <DropzoneS3Uploader
                  onFinish={handleFinishedUpload}
                  upload={uploadOptions}
                  s3Url={s3Url}
                  passChildrenProps={false}
                  maxSize={1024 * 1024 * 20}
                  className={classes.uploadzone}
                  style={{
                    width: "100%",
                    height: "200px",
                    background: "#FFFFFF",
                    border: "1px dashed #B8B8B8",
                    padding: "55px 0",
                  }}
                >
                  <div>
                    <ProgressState progress={progress} errorMessage={errorMessage} />
                  </div>
                </DropzoneS3Uploader>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                disabled={uploading || props.savingDocument}
                style={{ marginTop: "20px", opacity: (uploading || props.savingDocument) ? 0.5 : 1 }}
                onClick={() => setStep(1)}
              >
                Back
              </ButtonInc>
            </Grid>
          </Grid>
        )}

      </ModalInc>
    </>
  )
}

export default PolicyDocuments
